module.exports = __webpack_public_path__ + "img/logo-grupoauren-desktop.66ccdf15.svg";